import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@core/utils/cn';
import { Button } from './Button';

interface ErrorStateProps {
  readonly title?: string;
  readonly message?: string;
  readonly onRetry?: () => void;
  readonly className?: string;
}

/** Error state: icon + message + retry. Copy is translated by default. */
export function ErrorState({
  title,
  message,
  onRetry,
  className,
}: ErrorStateProps): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center gap-3 rounded-2xl border border-line bg-card px-6 py-12 text-center',
        className,
      )}
    >
      <span className="flex size-12 items-center justify-center rounded-full bg-danger/10 text-danger">
        <AlertTriangle size={24} aria-hidden="true" />
      </span>
      <p className="font-semibold text-text">{title ?? t('states.errorTitle')}</p>
      <p className="max-w-sm text-sm text-muted">{message ?? t('states.errorSub')}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-2">
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
}
